import { createContext } from "react";
import { IAccountContext } from "./types";

export const AccountContext = createContext<IAccountContext>({});
